import React, { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";

const WHATSAPP_NUMBER = "523347591562";
const DEFAULT_MESSAGE = encodeURIComponent(
  "¡Hola Burbujas de mami! 🍯 Me interesa saber más sobre sus productos."
);

export const WhatsAppButton = () => {
  const [visible, setVisible] = useState(false);
  const [tooltip, setTooltip] = useState(false);

  // Reveal after a small delay so it doesn't compete with page load
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    // Show tooltip once, after 4s, then hide it after 5s
    const showTip = setTimeout(() => setTooltip(true), 4000);
    const hideTip = setTimeout(() => setTooltip(false), 9000);
    return () => {
      clearTimeout(t);
      clearTimeout(showTip);
      clearTimeout(hideTip);
    };
  }, []);

  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${DEFAULT_MESSAGE}`;

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      data-testid="whatsapp-floating"
    >
      {/* Tooltip */}
      {tooltip && (
        <div
          className="absolute bottom-16 right-0 bg-white rounded-2xl shadow-xl border border-stone-200 p-3 pr-8 w-56 animate-in fade-in slide-in-from-bottom-2 duration-300"
          data-testid="whatsapp-tooltip"
        >
          <p className="text-sm text-stone-700 font-medium">
            ¿Necesitas ayuda? 💬
          </p>
          <p className="text-xs text-stone-500 mt-0.5">
            Escríbenos por WhatsApp
          </p>
          <button
            onClick={() => setTooltip(false)}
            className="absolute top-1.5 right-1.5 p-0.5 text-stone-400 hover:text-stone-700"
            aria-label="Cerrar"
          >
            <X className="w-3.5 h-3.5" />
          </button>
          {/* Arrow */}
          <div className="absolute -bottom-1.5 right-6 w-3 h-3 bg-white border-r border-b border-stone-200 rotate-45" />
        </div>
      )}

      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chatear por WhatsApp"
        className="group relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-green-600/30 hover:shadow-xl hover:shadow-green-600/40 hover:scale-110 active:scale-95 transition-all duration-200"
        data-testid="whatsapp-button"
      >
        {/* Pulse animation ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
        <MessageCircle className="w-7 h-7 relative z-10" fill="currentColor" strokeWidth={0} />
      </a>
    </div>
  );
};

export default WhatsAppButton;
